module.exports = __webpack_public_path__ + "static/tweet-a22cde49d87e2553ab3bcbb7c6d5a962.png";